import * as validators from './validators';
import { formatMoney } from './currency';
import { types as sdkTypes } from './sdkLoader';

const { Money } = sdkTypes;

/**
 * Composed final-form validators for a listing price field: required, plus a
 * minimum-amount check when the marketplace sets one.
 *
 * Lived in EditListingPricingAndStockForm until the dead wizard panels were
 * deleted; used by the one-page listing form and OfferForm.
 */
export const getPriceValidators = (listingMinimumPriceSubUnits, marketplaceCurrency, intl) => {
  const priceRequiredMsgId = { id: 'EditListingDetailsForm.setPriceError' };
  const priceRequiredMsg = intl.formatMessage(priceRequiredMsgId);
  const priceRequired = validators.required(priceRequiredMsg);

  const minPriceRaw = new Money(listingMinimumPriceSubUnits, marketplaceCurrency);
  const minPrice = formatMoney(intl, minPriceRaw);
  const priceTooLowMsgId = { id: 'EditListingPricingAndStockForm.priceTooLow' };
  const priceTooLowMsg = intl.formatMessage(priceTooLowMsgId, { minPrice });
  const minPriceRequired = validators.moneySubUnitAmountAtLeast(
    priceTooLowMsg,
    listingMinimumPriceSubUnits
  );

  return listingMinimumPriceSubUnits
    ? validators.composeValidators(priceRequired, minPriceRequired)
    : priceRequired;
};
